import {CLIENT_DISCOUNT_CODES} from './siteIds'

const config = {
  clientId: CLIENT_DISCOUNT_CODES,
  clientUrl: 'https://www.discountcodes.com/',
  privacyPolicyUrl: 'https://discountcodes.com/terms',
  termsUrl: 'https://discountcodes.com/terms',
  appName: 'Discountcodes.com',
  siteName: 'Discountcodes.com',
  price: 24.99,
  currency: 'USD',
  currencySymbol: '$',
  primaryColor: 'red',
  outlineFocusColor: 'focus:outline-blue-600',
  bgColor: 'bg-blue-600',
  hoverColor: 'bg-blue-600',
  focusVisibleColor: `focus-visible:outline-blue-600`,
  textColor: `text-blue-600`,
  hoverTextColor: `hover:text-blue-500`,
  brands: [
    {
      name: 'at-and-t-wireless',
      logo: '/popular-brands/at-and-t-wireless-coupons.png',
    },
    {name: 'avis', logo: '/popular-brands/avis-coupons.png'},
    {name: 'bose', logo: '/popular-brands/bose-coupons.png'},
    {
      name: 'h-and-r-block',
      logo: '/popular-brands/h-and-r-block-coupons.png',
    },
    {name: 'lenovo', logo: '/popular-brands/lenovo-coupons.png'},
    {name: 'oreo', logo: '/popular-brands/oreo-coupons.png'},
    {name: 'szul', logo: '/popular-brands/szul-coupons.png'},
    {name: 'tj-maxx', logo: '/popular-brands/tj-maxx-coupons.png'},
  ],
}
export default config
